// Shared helpers for string-list editing: one textarea, one entry per line.

export function ListTextarea({
  label,
  values,
  onChange,
  rows = 4,
}: {
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
  rows?: number;
}) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-medium text-gray-600">{label} (one per line)</span>
      <textarea
        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
        rows={rows}
        value={values.join('\n')}
        onChange={(e) => onChange(e.target.value.split('\n'))}
        onBlur={(e) =>
          onChange(
            e.target.value
              .split('\n')
              .map((line) => line.trim())
              .filter(Boolean),
          )
        }
      />
    </label>
  );
}

export function Bullets({ items }: { items: string[] }) {
  if (items.length === 0) return null;
  return (
    <ul className="list-disc space-y-0.5 pl-4 text-sm text-gray-700">
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}
